export default {
  title: 'Valider mes choix',
  cardFlex: {
    message: 'Space suits view from advices like intelligent spaces.',
  },
  price: {
    label: '{price} {exclTax} / {step} {unity}',
    none: '- €',
    labelOneUnit: '+ {price} {exclTax}',
  },
  mover: {
    title: 'Mon déménageur',
  },
  services: {
    title: 'Les services Nextories',
    alter: 'Modifier',
    submit: 'Valider',
    total: 'Total',
    footer: {
      title: 'En savoir plus',
    },
    errorValueChosen: {
      default: 'Veuillez saisir une valeur valide.',
      interval: 'Veuillez saisir une valeur entre {min} et {max}.',
      max: 'Veuillez saisir une valeur inférieur ou égale à {max}.',
      min: 'Veuillez saisir une valeur supérieur ou égale à {min}.',
    },
  },
};
